import { css } from "@emotion/react"
import styled from "@emotion/styled"

type RiskSelectorAreaProps = {
  isActive?: boolean
}

export const RiskSelectorArea = styled.div<RiskSelectorAreaProps>(({ isActive }) => ({
  ".bp5-icon-minus": { opacity: isActive ? 1 : 0 },
  cursor: isActive ? "pointer" : "default",
  "&:hover": {
    ".bp5-icon-minus": { opacity: 1 },
    cursor: "pointer",
  },
}))

export const minusIconCss = css({
  color: "white !important",
  marginTop: "-5px",
})

interface IconWrapperProps {
  margin: string
}

export const IconWrapper = styled.div<IconWrapperProps>`
  margin: ${props => props.margin};
  .bp5-icon {
    color: white !important;
  }
`
